import React from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";
import ReactRailsUJS from "react_ujs";

const PRINTS_PATH = "/apps/frame/prints";
const UPLOAD_TITLE = "What would you like to frame?";
const PRINTS_TITLE = "Select a print size";

let swapInFlight = false;
let popstateHandler;

// Swap the digital-upload layout for PrintSizeForm and point the address bar
// at the prints URL. Direct visits and refreshes still hit PrintsController.
// Anything that is not the prints page, or any failure, keeps the full navigation.
export function visitPrints(url) {
  if (!url) return;

  let destination;
  try {
    destination = new URL(url, window.location.origin);
  } catch (error) {
    window.location.href = url;
    return;
  }

  const layout = document.querySelector(".digital-upload-layout");
  const printsUrl = `${PRINTS_PATH}${destination.search}`;

  if (
    destination.origin !== window.location.origin ||
    destination.pathname !== PRINTS_PATH ||
    !layout ||
    swapInFlight
  ) {
    if (!swapInFlight) window.location.href = url;
    return;
  }

  swapInFlight = true;
  document.documentElement.style.cursor = "progress";

  return Promise.all([
    axios.get(`${PRINTS_PATH}.json${destination.search}`),
    import("./PrintSizeForm"),
  ])
    .then(([response, { default: PrintSizeForm }]) => {
      const props = response.data;
      if (!props || typeof props !== "object" || !props.image) {
        throw new Error("Print size presenter was not JSON");
      }

      window.history.pushState({ inlinePrintSize: true }, "", printsUrl);
      installPopstateReload(destination);
      ReactRailsUJS.unmountComponents(layout);

      const mount = replaceUploadLayout(layout);
      document.body.classList.replace("digital-upload-page", "print-size-page");
      document.body.classList.add("print-size-page");
      setPrintsTitle();
      window.scrollTo(0, 0);

      createRoot(mount).render(<PrintSizeForm {...props} />);
    })
    .catch(() => {
      window.location.href = printsUrl;
    })
    .finally(() => {
      swapInFlight = false;
      document.documentElement.style.cursor = "";
    });
}

function installPopstateReload(destination) {
  if (popstateHandler) window.removeEventListener("popstate", popstateHandler);

  // PrintSizeForm restores its own tab/size history without remounting.
  // Reload only when leaving this image, including Back to digital-upload.
  popstateHandler = () => {
    const current = new URL(window.location.href);
    if (
      current.pathname !== destination.pathname ||
      current.searchParams.get("image_key") !==
        destination.searchParams.get("image_key")
    ) {
      window.location.reload();
    }
  };
  window.addEventListener("popstate", popstateHandler);
}

function replaceUploadLayout(layout) {
  const page = document.createElement("div");
  page.className = "print-size-page";
  const mount = document.createElement("div");
  page.appendChild(mount);
  layout.replaceWith(page);
  return mount;
}

function setPrintsTitle() {
  if (document.title.includes(UPLOAD_TITLE)) {
    document.title = document.title.replace(UPLOAD_TITLE, PRINTS_TITLE);
    return;
  }

  document.title = PRINTS_TITLE;
}
